"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _RetailBuySell = require("../../../components/Retail/RetailBuySell");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./BuySellTabletsLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var classes = (0, _cssClassesHelper.getBEMClasses)('buy-sell-tablets-layout');
var BuySellTabletsLayout = function BuySellTabletsLayout() {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('make-transaction-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('make-transaction-col-1 ')
  }, /*#__PURE__*/_react["default"].createElement(_RetailBuySell.BuySellMakeTransactionContainer, null, /*#__PURE__*/_react["default"].createElement(_RetailBuySell.BuySellContainer, null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('make-transaction-col-2')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('order-overview-container')
  }, /*#__PURE__*/_react["default"].createElement(_RetailBuySell.BuySellOrderOverviewContainer, null)), /*#__PURE__*/_react["default"].createElement("hr", {
    className: classes('right-panel-divider')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('balances-container ')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('balances-title')
  }, t('Balances')), /*#__PURE__*/_react["default"].createElement(_RetailBuySell.BuySellBalancesContainer, null)))));
};
var _default = exports["default"] = BuySellTabletsLayout;